export default "__VITE_ASSET__DG0hUgxe__"